/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CircularContent } from '../../models/circular-content';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterCircularContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterCircularContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCircularContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CircularContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCircularContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CircularContent>>;
    })
  );
}

apiMasterCircularContentGetByCriteriaPost.PATH = '/api/Master/CircularContent/GetByCriteria';
